<template>
    <div v-click-outside="hideMarkDownTooltip" class="markdown">
        <div v-on:click="toggleMarkDownTooltip()"
             v-on:mouseenter="showTooltip = true"
             v-on:mouseleave="showTooltip = false"
             class="markdown-popup-trigger">
            <i class="fab fa-markdown"></i>
        </div>
        <tooltip v-bind:visible="showTooltip"
                 v-bind:position="'bottom'"
                 v-bind:text="'View Markdown help'"></tooltip>
        <div class="markdown-popup" v-show="isShowMarkDownTooltip">
            <div class="tooltip-container">
                <span class="tooltip-text tooltip-text--bottom text-left" v-bind:class="{'tooltip-visible' : true}">
                    <h5>This field accepts Markdown</h5>
                    Use Markdown to <b>style text</b> and <b>create links</b><span class="d-none d-sm-inline"> (e.g. to your T&Cs)</span>.<br/>
                    Here are the most useful syntax commands:
                    <table class="markdown-syntax">
                        <thead>
                            <th class="markdown-syntax__hdr-element">Element</th>
                            <th class="markdown-syntax__hdr-syntax">Syntax <span class="advice">(add the bold text)</span></th>
                        </thead>
                        <tr>
                            <td>Bold</td>
                            <td class="text-code">**<span class="markdown-syntax--user-text">bold text</span>**</td>
                        </tr>
                        <tr>
                            <td>Italic</td>
                            <td class="text-code">*<span class="markdown-syntax--user-text">italicized text</span>*</td>
                        </tr>
                        <tr>
                            <td>Link</td>
<!--                            <td class="text-code">[title](https://www.example.com)</td>-->
                            <td class="text-code markdown-syntax__links"><div>[<span class="markdown-syntax--user-text">title</span>]</div><div>(<span class="markdown-syntax--user-text">url</span>)</div></td>
                        </tr>
                        <tr>
                            <td>Unordered List (bullets)</td>
                            <td class="text-code">
                                <ul>
                                    <li>- <span class="markdown-syntax--user-text">First item</span></li>
                                    <li>- <span class="markdown-syntax--user-text">Second item</span></li>
                                    <li>- <span class="markdown-syntax--user-text">Third item</span></li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Ordered List</td>
                            <td class="text-code">
                                <ul>
                                    <li>1. <span class="markdown-syntax--user-text">First item</span></li>
                                    <li>2. <span class="markdown-syntax--user-text">Second item</span></li>
                                    <li>3. <span class="markdown-syntax--user-text">Third item</span></li>
                                </ul>
                            </td>
                        </tr>
                    </table>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Tooltip from './Tooltip'

    export default {
        name: 'Markdown',
        components: {
            Tooltip
        },
        props: {
        },
        data: function() {
            return {
                showTooltip: false,
                isShowMarkDownTooltip: false,
                canHideMarkdownTooltip: false
            }
        },
        computed: {
        },
        methods: {
            toggleMarkDownTooltip: function() {
                this.isShowMarkDownTooltip = !this.isShowMarkDownTooltip;
                // only allow outside click events once the popup is showing
                this.canHideMarkdownTooltip = false;
                setTimeout(() => {
                    this.canHideMarkdownTooltip = true;
                }, 200);
            },
            hideMarkDownTooltip: function() {
                if (this.canHideMarkdownTooltip) {
                    this.isShowMarkDownTooltip = false;
                    this.canHideMarkdownTooltip = false
                }
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/tooltips.scss";
    @import "../styles/components/markdown.scss";
</style>